"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _HiSelectableListItem = _interopRequireDefault(require("./HiSelectableListItem"));
var _helpers = require("../utils/helpers");
var _keycode = _interopRequireDefault(require("keycode"));
var _reactLazyload = _interopRequireWildcard(require("react-lazyload"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      padding: 0,
      backgroundColor: theme.palette.background3
    },
    suggestionFocus: {
      backgroundColor: theme.palette.action.hover,
      fontWeight: theme.typography.fontWeightMedium
    },
    parentRoot: {
      '&:focus': {
        backgroundColor: theme.palette.action.hover,
        fontWeight: theme.typography.fontWeightMedium
      }
    }
  };
};
var findSelectedItemParent = function findSelectedItemParent(arr, id) {
  if (id) {
    var res = arr.find(function (p) {
      var _p$children;
      return (_p$children = p.children) === null || _p$children === void 0 ? void 0 : _p$children.map(function (o) {
        return o.id;
      }).includes(id);
    });
    if (res) return res.id;
  }
  return null;
};

/**
 * Construit une liste d'item sélectionnable (avec checkbox)
 * - la navigation au clavier est gérée par l'event KeyDown
 * - le premier focus est géré sur le DidMount
 */
var HiSelectableList = /*#__PURE__*/function (_React$PureComponent) {
  function HiSelectableList(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiSelectableList);
    _this = _callSuper(this, HiSelectableList, [props]);
    _this.handleSelect = function (item) {
      return function (event) {
        if (_this.props.collapseParent && item.children) {
          _this.setState(function (prevState) {
            return {
              openedParent: prevState.openedParent === item.id ? null : item.id
            };
          });
        } else {
          _this.props.onSelect(event, item);
        }
      };
    };
    _this.handleKeyDown = function (event) {
      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      } else {
        var nextItem;
        var key = (0, _keycode.default)(event);
        if (key === 'down') {
          event.preventDefault();
          nextItem = (0, _helpers.getNextItemSelectable)(document.activeElement, 'down');
        } else if (key === 'up') {
          event.preventDefault();
          nextItem = (0, _helpers.getNextItemSelectable)(document.activeElement, 'up');
        }
        if (nextItem) {
          nextItem.focus();
        }
      }
    };
    /**
     * Build list item and children items
     *
     * @param item
     * @param index
     * @param level
     * @returns {*}
     */
    _this.buildRecursiveListItem = function (item, index) {
      var _item$icon, _item$icon$props;
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var _this$props = _this.props,
        checkedIcon = _this$props.checkedIcon,
        disabled = _this$props.disabled,
        disabledItemIdList = _this$props.disabledItemIdList,
        hideCheckbox = _this$props.hideCheckbox,
        hoverIcon = _this$props.hoverIcon,
        icon = _this$props.icon,
        lazy = _this$props.lazy,
        selectedItemIdList = _this$props.selectedItemIdList,
        sort = _this$props.sort,
        onKeyDown = _this$props.onKeyDown,
        onKeyUp = _this$props.onKeyUp,
        suggestionFocusIndex = _this$props.suggestionFocusIndex,
        classes = _this$props.classes,
        noPadding = _this$props.noPadding,
        others = (0, _objectWithoutProperties2.default)(_this$props, ["checkedIcon", "disabled", "disabledItemIdList", "hideCheckbox", "hoverIcon", "icon", "lazy", "selectedItemIdList", "sort", "onKeyDown", "onKeyUp", "suggestionFocusIndex", "classes", "noPadding"]);
      if (sort && item.children) {
        item.children.sort(_this.compareItem);
      }
      var placeholderContent = /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '90%',
          padding: '8px 6px',
          height: 40,
          position: 'sticky',
          left: 0
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          backgroundColor: '#F5F5F5',
          width: '100%',
          height: '100%',
          borderRadius: 4
        }
      }));
      var handleKeyDown = function handleKeyDown() {
        if (onKeyDown) {
          onKeyDown();
        }
      };
      var itemComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: item.id
      }, /*#__PURE__*/_react.default.createElement(_HiSelectableListItem.default, (0, _extends2.default)({}, others, {
        checkedIcon: checkedIcon,
        disabled: disabled || disabledItemIdList.includes(item.id),
        hideCheckbox: hideCheckbox,
        hoverIcon: hoverIcon,
        icon: icon,
        color: (item === null || item === void 0 ? void 0 : (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : (_item$icon$props = _item$icon.props) === null || _item$icon$props === void 0 ? void 0 : _item$icon$props.color) || 'inherit',
        level: noPadding ? 0 : level,
        onSelect: item.selectable !== false ? _this.handleSelect(item) : undefined,
        onKeyDown: item.selectable !== false ? handleKeyDown : undefined,
        onKeyUp: onKeyUp,
        selected: selectedItemIdList.includes(item.id)
        // item props override upper props (disabled, hideCheckbox, icon, level...)
        ,
        item: item,
        classes: {
          root: classes.parentRoot,
          listItem: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.suggestionFocus, index === suggestionFocusIndex))
        },
        collapseHeader: _this.props.collapseParent && item.children && item.children.length > 0,
        opened: _this.state.openedParent === item.id,
        group: group
      }, item)), item.children && item.children.length > 0 && (_this.props.collapseParent && level === 0 ? /*#__PURE__*/_react.default.createElement(_Collapse.default, {
        id: "group-".concat(item.id),
        in: _this.state.openedParent === item.id,
        timeout: "auto"
      }, item.children.filter(function (subItem) {
        return !(subItem.displayed === false);
      }).map(function (subItem) {
        return _this.buildRecursiveListItem(subItem, index, level + 1, item.id);
      })) : item.children.filter(function (subItem) {
        return !(subItem.displayed === false);
      }).map(function (subItem) {
        return _this.buildRecursiveListItem(subItem, index, level + 1);
      })));
      if (lazy) {
        return /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
          key: item.id,
          height: 40,
          offset: 400,
          once: true,
          overflow: true,
          placeholder: placeholderContent
        }, itemComponent);
      }
      return itemComponent;
    };
    _this.compareItem = function (a, b) {
      if (_this.props.comparItemFunc) {
        return _this.props.comparItemFunc(a, b);
      }
      if (a.label === undefined || b.label === undefined) {
        return 0;
      }
      var sortAppendList = _this.props.sortAppendList;
      if (sortAppendList.indexOf(a.id) < sortAppendList.indexOf(b.id)) {
        return 1;
      }
      if (sortAppendList.indexOf(a.id) > sortAppendList.indexOf(b.id)) {
        return -1;
      }
      return (0, _helpers.foldAccents)(a.label.toString().toLowerCase()) > (0, _helpers.foldAccents)(b.label.toString().toLowerCase()) ? 1 : -1;
    };
    var openedParent;
    if (props.collapseParent) {
      if (props.selectedItemIdList[0]) {
        openedParent = findSelectedItemParent(props.itemList, props.selectedItemIdList[0]);
      } else {
        openedParent = props.itemList[0].id;
      }
    }
    _this.state = {
      openedParent: openedParent
    };
    return _this;
  }
  (0, _inherits2.default)(HiSelectableList, _React$PureComponent);
  return (0, _createClass2.default)(HiSelectableList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Focus on last item selected
      if (this.props.overlay && this.props.overlay.getElementsByTagName('li')[0]) {
        if (Array.isArray(this.props.value) && this.props.value.length > 0 || !Array.isArray(this.props.value) && this.props.value) {
          var item = this.props.overlay.getElementsByTagName('li')[0];
          var lastSelectedValue = Array.isArray(this.props.value) ? this.props.value[this.props.value.length - 1] : this.props.value;
          var index = 0;
          this.props.itemList.forEach(function (option) {
            if (option.id === lastSelectedValue) {
              item = _this2.props.overlay.getElementsByTagName('li')[index];
            }
            index++;
            if (option.children && option.children.length) {
              option.children.forEach(function (option) {
                if (option.id === lastSelectedValue) {
                  item = _this2.props.overlay.getElementsByTagName('li')[index];
                }
                index++;
              });
            }
          });
          item && item.focus();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.lazy && prevProps.itemList !== this.props.itemList) {
        (0, _reactLazyload.forceCheck)();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        itemList = _this$props2.itemList,
        sort = _this$props2.sort;
      if (sort) {
        itemList.sort(this.compareItem);
      }
      return /*#__PURE__*/_react.default.createElement(_List.default, {
        className: classes.root,
        onKeyDown: this.handleKeyDown,
        ref: function ref(el) {
          _this3.el = el;
        }
      }, itemList.filter(function (item) {
        return !(item.displayed === false);
      }) // don't remove if undefined
      .map(function (item, index) {
        return _this3.buildRecursiveListItem(item, index);
      }));
    }
  }]);
}(_react.default.PureComponent);
HiSelectableList.defaultProps = {
  allSelected: false,
  disabled: false,
  disabledItemIdList: [],
  hideCheckbox: false,
  lazy: true,
  selectedItemIdList: [],
  sort: false,
  sortAppendList: ['_all'],
  collapseParent: false
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSelectableList',
  index: 51
})(HiSelectableList);